// @copyright  2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'settings.link.title.api-tokens': 'API Tokens',
    'settings.link.description.api-tokens': 'Create and revoke personal access tokens for the API.',

    'settings.page.api-tokens.title': 'API Tokens',
    'settings.page.api-tokens.description': 'Personal access tokens let external applications act on your behalf through the API. A token can only do what you can do, limited to the roles you assign it.',

    'settings.page.api-tokens.organisation_id.label': 'Organisation ID (X-Organisation-Id header)',
    'settings.page.api-tokens.organisation_id.help': 'Send this as the X-Organisation-Id header on every API request, to tell HeadOffice which organisation to act on. It is the id of the organisation you are currently signed in to.',
    'settings.page.api-tokens.organisation_id.copy_success': 'Organisation ID copied to clipboard.',
    'settings.page.api-tokens.organisation_id.unavailable': 'Your Organisation ID could not be determined. Reload the page or switch organisation, then try again — API calls need this value as the X-Organisation-Id header.',

    'settings.page.api-tokens.create': 'Create token',
    'settings.page.api-tokens.empty': 'You have not created any API tokens yet.',
    'settings.page.api-tokens.loading': 'Loading your API tokens…',
    'settings.page.api-tokens.load_error': 'Sorry, there was an error loading your API tokens.',

    'settings.page.api-tokens.last_used': 'Last used',
    'settings.page.api-tokens.never_used': 'Never',
    'settings.page.api-tokens.expires': 'Expires',
    'settings.page.api-tokens.never_expires': 'Never expires',
    'settings.page.api-tokens.created': 'Created',

    'settings.page.api-tokens.revoke': 'Revoke',
    'settings.page.api-tokens.revoking': 'Revoking…',
    'settings.page.api-tokens.revoke_success': 'The token was revoked.',
    'settings.page.api-tokens.revoke_error': 'Sorry, the token could not be revoked.',

    'settings.page.api-tokens.modal.create_title': 'Create API Token',
    'settings.page.api-tokens.modal.token_name': 'Token name',
    'settings.page.api-tokens.modal.token_name_placeholder': 'e.g. Reporting integration',
    'settings.page.api-tokens.modal.roles': 'Roles',
    'settings.page.api-tokens.modal.roles_help': 'The token can only do what you can do — selecting a role never grants more than your own access. Choose the narrowest role that will do the job. Select at least one role.',
    'settings.page.api-tokens.modal.no_roles': 'You have no roles available to grant.',
    'settings.page.api-tokens.modal.roles_load_error': 'Sorry, there was an error loading the roles you can grant.',
    'settings.page.api-tokens.modal.roles_unavailable': 'The roles you can grant could not be loaded, so there are none to choose from. Reload the page and try again.',
    'settings.page.api-tokens.modal.roles_filter_label': 'Filter roles',
    'settings.page.api-tokens.modal.roles_filter_placeholder': 'Filter roles…',
    'settings.page.api-tokens.modal.roles_filter_clear': 'Clear the role filter',
    'settings.page.api-tokens.modal.roles_no_matches': 'No roles match that filter.',
    'settings.page.api-tokens.modal.roles_selected_summary': '{selected} of {total} roles selected.',
    'settings.page.api-tokens.modal.roles_hidden_by_filter': 'Some selected roles are hidden by the filter — they are still selected.',
    'settings.page.api-tokens.modal.expires_in_days': 'Expiry (days)',
    'settings.page.api-tokens.modal.expires_in_days_help': 'Optional. Enter a number of days between 1 and 365. Leave blank for a token that never expires.',
    'settings.page.api-tokens.modal.revoke_message': 'Are you sure you want to revoke "{name}"? Any application using this token will immediately lose access.',

    'settings.page.api-tokens.button.cancel': 'Cancel',
    'settings.page.api-tokens.button.create': 'Create token',
    'settings.page.api-tokens.button.copy': 'Copy',
    'settings.page.api-tokens.button.done': 'Done',

    'settings.page.api-tokens.validation.token_name_required': 'Please enter a token name.',
    'settings.page.api-tokens.validation.roles_required': 'Please select at least one role.',
    'settings.page.api-tokens.validation.expires_range': 'Expiry must be a whole number of days between 1 and 365.',

    'settings.page.api-tokens.created_title': 'Your new API token',
    'settings.page.api-tokens.created_warning': 'Copy this token now — it will not be shown again.',
    'settings.page.api-tokens.copy_success': 'Token copied to clipboard.',
    'settings.page.api-tokens.copy_error': 'Could not copy the token. Please copy it manually.',

    'settings.page.api-tokens.create_error': 'Sorry, the token could not be created.',
};
